import { render, staticRenderFns } from "./pendingConfirm.vue?vue&type=template&id=36fffa2b&scoped=true&"
import script from "./pendingConfirm.vue?vue&type=script&lang=js&"
export * from "./pendingConfirm.vue?vue&type=script&lang=js&"
import style0 from "./pendingConfirm.vue?vue&type=style&index=0&id=36fffa2b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fffa2b",
  null
  
)

export default component.exports